import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import Spinner from 'react-bootstrap/Spinner';

interface SpinnerProps {
    className? : string,
    show? : boolean
    variant? : string
}

export const AccessibleSpinner = ({show, className, variant} : SpinnerProps) =>
{
    const {t} = useTranslationWithOverride();

    return show ? (
        <Spinner className={className} size="sm" animation="border" variant={variant}>
            <span className="visually-hidden">{t("common.loading")}</span>
        </Spinner>
    ) : null;
}
